import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import GetByIdRequest from '../../../users/base/i-service/models/requests/GetByIdRequest';
import GetAdminsWithProjectListRequest from '../../../projects/performers/i-service/model/request/GetAdminsWithProjectListRequest';
import OwnedUsersRequest from '../../../projects/performers/i-service/model/request/OwnedUsersRequest';
import GetOwnedDetailUsersRequest from '../../../projects/performers/i-service/model/request/GetOwnedDetailUsersRequest';
import AdminsListForProjectRequest from '../../../projects/performers/i-service/model/request/AdminsListForProjectRequest';
import WsResponseModelT from '../../../schema-builder-server/models/WsResponseModelT';
import GetByIdResponse from '../../../users/base/i-service/models/responses/GetByIdResponse';
import GetAdminsWithProjectListResponse from '../../../projects/performers/i-service/model/response/GetAdminsWithProjectListResponse';
import OwnedUsersResponse from '../../../projects/performers/i-service/model/response/OwnedUsersResponse';
import GetOwnedDetailUsersResponse from '../../../projects/performers/i-service/model/response/GetOwnedDetailUsersResponse';
import ShortProfile from '../../../users/profile/i-service/models/ShortProfile';

export default class PerformersListService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	GetByIdEvent = new Events<WsResponseModelT<GetByIdResponse>>();
	GetAdminsWithProjectListEvent = new Events<WsResponseModelT<GetAdminsWithProjectListResponse>>();
	GetOwnedUsersEvent = new Events<WsResponseModelT<OwnedUsersResponse>>();
	GetOwnedDetailUsersEvent = new Events<WsResponseModelT<GetOwnedDetailUsersResponse>>();
	GetAdminsListForProjectEvent = new Events<WsResponseModelT<Array<ShortProfile>>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('PerformersListService', 'GetById', 'Main', (res: WsResponseModelT<GetByIdResponse>) => {
			self.GetByIdEvent.trigger(res);
		});
		webApiService.on('PerformersListService', 'GetAdminsWithProjectList', 'Main', (res: WsResponseModelT<GetAdminsWithProjectListResponse>) => {
			self.GetAdminsWithProjectListEvent.trigger(res);
		});
		webApiService.on('PerformersListService', 'GetOwnedUsers', 'Main', (res: WsResponseModelT<OwnedUsersResponse>) => {
			self.GetOwnedUsersEvent.trigger(res);
		});
		webApiService.on('PerformersListService', 'GetOwnedDetailUsers', 'Main', (res: WsResponseModelT<GetOwnedDetailUsersResponse>) => {
			self.GetOwnedDetailUsersEvent.trigger(res);
		});
		webApiService.on('PerformersListService', 'GetAdminsListForProject', 'Main', (res: WsResponseModelT<Array<ShortProfile>>) => {
			self.GetAdminsListForProjectEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Получение информации о пользователе по Id
	 */
	async GetById(request: GetByIdRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersListService',
			Method: 'GetById',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка администраторов проектов
	 */
	async GetAdminsWithProjectList(request: GetAdminsWithProjectListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersListService',
			Method: 'GetAdminsWithProjectList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить список пользователей и краткую информацыю о них
	 */
	async GetOwnedUsers(request: OwnedUsersRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersListService',
			Method: 'GetOwnedUsers',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить список пользователей и краткую информацыю о них с проектами
	 */
	async GetOwnedDetailUsers(request: GetOwnedDetailUsersRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersListService',
			Method: 'GetOwnedDetailUsers',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * получить список админов проекта
	 */
	async GetAdminsListForProject(request: AdminsListForProjectRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersListService',
			Method: 'GetAdminsListForProject',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Получение информации о пользователе по Id
	 */
	async getByIdAsync(request: GetByIdRequest): Promise<GetByIdResponse> {
		return new Promise<GetByIdResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersListService',
				Method: 'GetById',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetByIdResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetByIdResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка администраторов проектов
	 */
	async getAdminsWithProjectListAsync(request: GetAdminsWithProjectListRequest): Promise<GetAdminsWithProjectListResponse> {
		return new Promise<GetAdminsWithProjectListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersListService',
				Method: 'GetAdminsWithProjectList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetAdminsWithProjectListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetAdminsWithProjectListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить список пользователей и краткую информацыю о них
	 */
	async getOwnedUsersAsync(request: OwnedUsersRequest): Promise<OwnedUsersResponse> {
		return new Promise<OwnedUsersResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersListService',
				Method: 'GetOwnedUsers',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<OwnedUsersResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as OwnedUsersResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить список пользователей и краткую информацыю о них с проектами
	 */
	async getOwnedDetailUsersAsync(request: GetOwnedDetailUsersRequest): Promise<GetOwnedDetailUsersResponse> {
		return new Promise<GetOwnedDetailUsersResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersListService',
				Method: 'GetOwnedDetailUsers',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetOwnedDetailUsersResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetOwnedDetailUsersResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * получить список админов проекта
	 */
	async getAdminsListForProjectAsync(request: AdminsListForProjectRequest): Promise<Array<ShortProfile>> {
		return new Promise<Array<ShortProfile>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersListService',
				Method: 'GetAdminsListForProject',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Array<ShortProfile>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<ShortProfile>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}